var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stats-widget',{attrs:{"title":_vm.$t('Completed'),"color":"accent","icon":"mdi-progress-clock","stat":_vm.completedOrdersCount}})
}
var staticRenderFns = []

export { render, staticRenderFns }